import React from 'react';

import styled from '@emotion/styled';

import Tooltip from '../Tooltip/Tooltip';

interface ChartWrapperProps {
  children?: React.ReactNode;
  label?: string;
  maxWidth?: string;
  height?: string;
  className?: string;
  tooltipData?: string;
  radius?: string;
}

const ChartWrapper: React.FC<ChartWrapperProps> = ({
  children,
  label,
  maxWidth,
  height,
  className,
  tooltipData,
  radius,
}) => {
  return (
    <Container
      maxWidth={maxWidth}
      height={height}
      radius={radius}
      className={className ?? ''}
    >
      <LabelArea>
        <Label className={className ?? ''}>{label}</Label>{' '}
        {tooltipData && <Tooltip content={tooltipData} />}
      </LabelArea>
      <ChartContent className={className ?? ''}>{children}</ChartContent>
    </Container>
  );
};

export default ChartWrapper;

interface ContainerProps {
  maxWidth?: string;
  height?: string;
  radius?: string;
}

const Container = styled.div<ContainerProps>`
  padding: 12px 24px;
  border-radius: ${({ radius }: { radius?: string }) => radius ?? '6px'};
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  width: 100%;
  height: ${({ height }: { height?: string }) => height ?? 'auto'};
  gap: 12px;
  /* min-height: 300px; */
  display: flex;
  flex-direction: column;
  /* TODO:: set this to it's default */
  max-width: ${({ maxWidth }: { maxWidth?: string }) => maxWidth ?? ''};
  background-color: white;

  &.borderless {
    border: none;
    padding: 0;
    margin-right: auto;
    align-items: flex-start;
  }
`;

const LabelArea = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  margin-bottom: 12px;
`;

const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;

  &.small-label {
    font-size: 14px;
    font-weight: 500;
    color: #6e7079;
    /* margin-bottom: 8px; */
  }
`;

const ChartContent = styled.div`
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
  /* min-height: 250px; */
  /* flex: 1; */
`;
